module.exports = __webpack_public_path__ + "img/img27.f4426721.svg";